import React from "react";
import { navigate } from '@reach/router'
import * as styled from "./styled"

export default ({children}) => {
    return (
        <>
            <styled.NavBarWrapper>
                <styled.LinkButton onClick={() => navigate(`/users/createAdminUser`) } selected={window.location.href.includes("users/createAdminUser")}>Create User</styled.LinkButton>
                <styled.LinkButton onClick={() => navigate(`/users/superUserList`) } selected={window.location.href.includes("users/superUserList")}>View Super Users</styled.LinkButton>
            </styled.NavBarWrapper>
            {children}
        </>

    )
}
